/**
 * 组图上传图片（图片库）
 * */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Input} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";
import Titlepicfile from "../../../../components/titlepicfile/Titlepicfile";
import {Scrollbars} from "react-custom-scrollbars";

const {Search} = Input;

class ImagesGallery extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            viewInformation: {
                findPicture: ''//输入搜索内容
            },
            url: {
                getPersonOrDeptUrl: "/search-server/search/getList/picture/personOrDept",//我的部门图片库
                getPersonUrl: "/search-server/search/getList/picture/person",//我的图片库
            },
            params: {
                "pageNum": 1,
                "pageSize": 9999,
                "keyword": ""
            },//图片库查询字段
            zykPicList: [],//图片库
            onlyMyPics: false,
            checked: [],
        }
    }

    componentDidMount() {
        this.getZykPicList()
    }

    getZykPicList = () => {
        let config = this.state.onlyMyPics ? 'getPersonUrl' : 'getPersonOrDeptUrl';
        let url = this.state.url[config];
        this.request({
            url,
            body: this.state.params,
            method: "post",
            contentType: 'json',
            callBack: (res) => {
                let zykPicList = [];
                if (res && res.data) {
                    zykPicList = res.data
                }
                this.setState({zykPicList});
                console.log(res)
            }
        })
    };

    render() {
        return (
            <div>
                {this.renderSearch()}
                {this.renderPicList()}
            </div>
        );
    }

    renderSearch = () => {
        return (
            <div style={{display: 'flex', justifyContent: 'space-between',}}>
                <Search
                    allowClear={true}
                    className="searchInput"
                    placeholder={'请输入图片搜索内容'}
                    onSearch={this.onSearch}
                    style={{width: 224, height: 32,}}
                />
                <div style={{}}>
                    <Checkbox checked={this.state.onlyMyPics} onChange={(e) => {
                        this.state.onlyMyPics = e.target.checked;
                        this.getZykPicList()
                    }}>仅我的资源</Checkbox>
                </div>
            </div>
        )
    };
    renderPicList = () => {
        console.log(this.state.zykPicList)
        return (
            <Scrollbars style={{height: 332}}>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    {
                         this.state.zykPicList.map((item, index) => {
                            let checked = this.state.checked && this.state.checked.findIndex && this.state.checked.findIndex(item2=>item2.id==item.id) > -1;
                            return (
                                <div style={{position: 'relative', marginRight: 24, marginTop: 24,}} key={index}>
                                    <Titlepicfile src={item.icon} style={{
                                        width: 120,
                                        height: 120,
                                    }}/>
                                    <div style={{fontSize:14,width:107,whiteSpace:'nowrap', overflow: 'hidden',textOverflow: 'ellipsis'}} title={item.name}>
                                        {item.name}
                                    </div>
                                    <Checkbox checked={checked}
                                              onChange={(e) => {
                                                  let checked;
                                                  // console.log('e.target.checked',e.target.checked)
                                                  if (e.target.checked) {
                                                      if(this.state.checked.findIndex(item1=>item1.id==item.id) < 0) {
                                                          checked = [...this.state.checked,item];
                                                      }
                                                  } else {
                                                      checked = this.state.checked.filter(Item => Item.id != item.id);
                                                  }
                                                  // console.log('checked',checked);
                                                  if(typeof this.props.onChange == 'function') {
                                                      let zykList = checked.map(item3=>{
                                                          let newItem  = {
                                                              ...item3,
                                                              url:item3.path,
                                                              uid:item3.id
                                                          };
                                                          return newItem
                                                      });
                                                      this.props.onChange(zykList)
                                                  }
                                                  this.setState({checked: checked})
                                              }} style={{position: 'absolute', top: 8, right: 8, zIndex: 9}}/>
                                </div>
                            )
                        })
                    }
                </div>
            </Scrollbars>
        )
    };

    //输入框改变复制
    onSearch = (value, event) => {
        this.state.params.keyword = value;
        this.getZykPicList()
    }

}

ImagesGallery.propTypes = {};

export default ImagesGallery;